<template>
  <div class="contact-person w-100" :class="{ 'h-100': loading }">
    <div class="w-100 h-100 mt-5 pt-5" v-if="loading">
      <Loading />
    </div>
    <div
      class="contact-data w-100 text-center mt-5 pt-1"
      v-if="!loading && person"
    >
      <div v-if="profileInfo.intermediary_persons.length > 0">
        <a :href="'mailto:' + intermediary.email">
          <font-awesome-icon
            :icon="['far', 'envelope']"
            class="color-yellow mr-1"
          />
          {{ intermediary.email }}
        </a>
        <a :href="'tel:' + intermediary.phone">
          <font-awesome-icon
            :icon="['fas', 'phone']"
            class="color-yellow mr-1"
          />
          {{ intermediary.phone }}
        </a>
        <a :href="'mailto:' + intermediary.email" class="btn btn-warning mt-4">
          Kontaktovať
        </a>
      </div>
      <div v-else>
        <a :href="'mailto:' + person.email">
          <font-awesome-icon
            :icon="['far', 'envelope']"
            class="color-yellow mr-1"
          />
          {{ person.email }}
        </a>
        <a :href="'tel:' + cleanPhone" v-if="cleanPhone">
          <font-awesome-icon
            :icon="['fas', 'phone']"
            class="color-yellow mr-1"
          />
          {{ person.phone }}
        </a>
        <a :href="'mailto:' + person.email" class="btn btn-warning mt-4">
          Kontaktovať
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { publicPath } from "@/main";
import Loading from "./Loading";
import { getImageFromBytea } from "@/store/helpers";

export default {
  name: "ContactPerson",
  components: { Loading },
  mounted() {
    this.$store.dispatch("content/salesPerson");
    this.$store.dispatch("content/intermediary");
  },
  computed: {
    loading() {
      return this.$store.state.content.loadingContact;
    },
    profileInfo() {
      return this.$store.state.account.profileInfo;
    },
    person() {
      return this.$store.state.content.salesPerson;
    },
    intermediary() {
      return this.$store.state.content.intermediary;
    },
    cleanPhone() {
      return this.person === null ? "" : this.person.phone.replace(/\s+/g, "");
    }
  },
  methods: {
    getImage(input) {
      return getImageFromBytea(input);
    }
  },
  data() {
    return {
      publicPath: publicPath
    };
  }
};
</script>

<style lang="scss" scoped>
.contact-person {
  p {
    font-size: 13px;
    margin-bottom: 10px;
  }

  .name {
    display: block;
    margin-bottom: 5px;
    font-size: 22px;
  }

  a:not(.btn) {
    color: $secondary-text;
    font-size: 16px;
    display: block;
  }

  a:not(.btn):hover {
    color: $yellow;
  }

  .contact-data {
    padding-bottom: 30px;
    margin-top: 10px;
  }

  .contact-photo-wrapper {
    display: flex;
    align-items: flex-end;
    justify-content: center;

    &.global-image {
      align-items: center;
      margin-top: -50px;

      .img-fluid {
        max-width: 80px;
      }
    }
  }
}
</style>
